import * as React from 'react'
import { useOutletContext, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { employeeUser } from 'modules/core/store/collections/users'

import employees from 'modules/employees/store/collections/employees'
import SplitView from 'modules/reviews/pages/performance/ReviewAnswer/SplitViewReviewAnswerPage/SplitView'

const SplitViewReviewAnswerPage = () => {
  const { id, review_id: formId } = useParams()
  const { hasCompetencies } = useOutletContext<{
    hasCompetencies: boolean
  }>()
  const employeeId = Number(id)
  const reviewId = Number(formId)
  const { navigation } = useNavigation()
  const back = navigation.employees.id.reviews.reviewId.answers.fullPath({
    id: employeeId,
    review_id: reviewId,
  })
  const employee = employees.get(employeeId)
  const user = employee && employeeUser(employee)

  return (
    <SplitView
      formId={reviewId}
      userId={Number(user?.get('id'))}
      back={back}
      canSeeCompetencies={hasCompetencies}
      // TODO: we need to wait employee migration to toggle true
      useResponsivePage={false}
    />
  )
}

export default SplitViewReviewAnswerPage
